import React from "react";
import { Form, Input, Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import styles from "./careers.module.css";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/footer/footer";
import sectionImage from "../../assets/images/careers/sectionImage.png";

const CareersForm = () => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log("Success:", values);
  };

  return (
    <>
      <NavBar />
      <div className={styles.container}>
        <div className={styles.formContainer}>
          <h2 className={styles.header}>Careers</h2>
          <Form
            form={form}
            name="careers"
            onFinish={onFinish}
            layout="vertical"
            className={styles.form}
          >
            <Form.Item
              name="fullName"
              label="Full Name"
              className={styles.formItem}
            >
              <Input
                placeholder="Full Name"
                style={{ height: "3rem", borderRadius: "15px" }}
              />
            </Form.Item>

            <Form.Item
              name="address"
              label="Address"
              className={styles.formItem}
            >
              <Input
                placeholder="Address"
                style={{ height: "3rem", borderRadius: "15px" }}
              />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email Address"
              className={styles.formItem}
            >
              <Input
                type="email"
                placeholder="example@gmail.com"
                style={{ height: "3rem", borderRadius: "15px" }}
              />
            </Form.Item>

            <Form.Item
              name="mobile"
              label="Mobile Number"
              className={styles.formItem}
            >
              <Input
                type="tel"
                placeholder="1234568890"
                style={{ height: "3rem", borderRadius: "15px" }}
              />
            </Form.Item>

            <Form.Item
              name="upload"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) {
                  return e;
                }
                return e?.fileList;
              }}
              className={styles.formItem}
            >
              <Upload name="cv" action="/upload.do" listType="text">
                <span className={styles.upload}>Upload CV</span>{" "}
                <Button className={styles.uploadBtn + " uploadHover"}>
                  Choose file
                </Button>
                <span className={styles.choose}>No file chosen</span>
              </Upload>
            </Form.Item>

            <Form.Item className={styles.formItem}>
              <Button
                type="primary"
                htmlType="submit"
                className={styles.btn + " btnSubmit"}
              >
                Submit Now
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className={styles.image}>
          <img src={sectionImage} alt="Careers" />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CareersForm;
